import { ComponentLoader } from 'cat-ecommerce-alloy';
import styles from './styles.module.scss';
import cx from 'classnames';

const Loader = () => {
  return (
    <div className={cx('position-relative mt-5', styles['loader'])}>
      <ComponentLoader size="small" />
    </div>
  );
};

export default Loader;
